import TimeProgressBar from './TimeProgressBar';
import useTimer, {getDatesDifferenceInSeconds} from '../../../hooks/useTimer';
import {FC, useMemo} from 'react';
import {AlertSettingsProps} from '../../settings/alert_alarm/types';
import {calculateAlertRange} from './helpers/calculateAlertRange';
import ProcessExpiredTime from '../../processes/ProcessExpiredTime';

type LiveTimeProgressBarPops = {
  startedAt: string,
  completedAt: Nullable<string>,
  targetTime: number,
  alertSettings: Nullable<AlertSettingsProps>,
  isCurrentlyRunning?: boolean,
  shouldShowExpiredIcon?: boolean,
  hasIntervals?: boolean,
  processExpiredTimeFormat?: (time: number) => void
};

const LiveTimeProgressBar: FC<LiveTimeProgressBarPops> = ({
  startedAt,
  completedAt,
  targetTime,
  alertSettings,
  isCurrentlyRunning = false,
  hasIntervals = false,
  shouldShowExpiredIcon = true,
  processExpiredTimeFormat
}) => {
  const alertRange = useMemo(() => {
    if (!alertSettings) return 0;

    const {relative, relativeRange, absoluteRange} = alertSettings;
    return calculateAlertRange(
        relative,
        relativeRange,
        absoluteRange,
        targetTime
    );
  }, [JSON.stringify(alertSettings)]);

  const initialDatesDiff = useMemo(() => {
    return getDatesDifferenceInSeconds(startedAt, completedAt);
  }, [startedAt, completedAt]);

  const {timeDiffInSeconds} = useTimer({
    initialDiff: initialDatesDiff,
    initialActive: !!startedAt && !completedAt
  });

  return (
    <TimeProgressBar
      currentTimeInSeconds={timeDiffInSeconds}
      targetTimeInSeconds={targetTime}
      alertRangeInSeconds={alertRange}
      shouldShowExpiredIcon={shouldShowExpiredIcon}
      isCurrentlyRunning={isCurrentlyRunning}
      hasIntervals={hasIntervals}
    >{processExpiredTimeFormat && (
        <ProcessExpiredTime
          startedAt={startedAt}
          completedAt={completedAt}
          targetTime={targetTime}
          alertSettings={alertSettings}
          timeFormat={processExpiredTimeFormat}
        />
      )}
    </TimeProgressBar>
  );
};

export default LiveTimeProgressBar;
